import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Mail, Phone, Linkedin, FileText, Target, Users, Award, ChevronRight } from "lucide-react";
import { useState } from "react";
const Index = () => {
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Navigation */}
      <nav className="bg-white/80 backdrop-blur-sm border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">AC</span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-xl text-slate-800">aéro-copywriter</span>
                <span className="text-sm text-slate-600">Expert communication aéronautique</span>
              </div>
            </div>
            <div className="hidden md:flex space-x-8">
              <button onClick={() => document.getElementById('services')?.scrollIntoView({
              behavior: 'smooth'
            })} className="text-slate-600 hover:text-blue-600 transition-colors">Services</button>
              <button onClick={() => document.getElementById('portfolio')?.scrollIntoView({
              behavior: 'smooth'
            })} className="text-slate-600 hover:text-blue-600 transition-colors">Portfolio</button>
              <button onClick={() => document.getElementById('apropos')?.scrollIntoView({
              behavior: 'smooth'
            })} className="text-slate-600 hover:text-blue-600 transition-colors">A propos</button>
              <button onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} className="text-slate-600 hover:text-blue-600 transition-colors">Contact</button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 opacity-95"></div>
        <div className="absolute inset-0">
          <img src="/images/charles_de_gaulle_hero.jpg" alt="Porte-avions Charles de Gaulle" className="w-full h-full object-cover" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-4">
            Bertrand KREBS
            <span className="block text-yellow-400 text-3xl lg:text-4xl mt-2">COPYWRITER</span>
          </h1>
          <div className="text-xl lg:text-2xl text-white font-medium mb-6 max-w-4xl mx-auto drop-shadow-lg">
            <p className="mb-2">Officier de Marine et pilote de chasse-embarquée</p>
            <p className="mb-4">Ingénieur exportation puis analyste stratégique chez Sextant Avionique</p>
            <p className="text-lg lg:text-xl text-blue-100 italic"></p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" onClick={() => document.getElementById('services')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-yellow-500 hover:bg-yellow-600 text-blue-900 font-semibold">
              Découvrir mes services
              <ChevronRight className="ml-2 h-5 w-5" />
            </Button>
            <Button size="lg" variant="outline" onClick={() => document.getElementById('portfolio')?.scrollIntoView({
            behavior: 'smooth'
          })} className="border-white text-white hover:bg-white hover:text-blue-900">
              Voir mon portfolio
            </Button>
          </div>
        </div>
      </section>

      {/* Accroche HERO + Tableau */}
      <section className="py-16 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Accroche */}
          <div className="text-center mb-12">
            <h2 className="text-2xl lg:text-3xl font-bold text-slate-800 mb-6">
              <span className="block mb-2">Vos contenus techniques manquent-!ls d'impact ou de clarté ?</span>
              <span className="block mb-2 text-blue-600">Je les transforme en messages <strong>précis</strong>, <strong>percutants</strong> et <strong>authentiques</strong></span>
              <span className="block text-lg text-slate-600">Grâce à ma triple expertise de pilote de chasse, d'officier de marine et d'ingénieur.</span>
            </h2>
          </div>
          
          {/* Tableau */}
          <div className="max-w-6xl mx-auto">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b-2 border-blue-600">
                    <th className="text-left py-4 px-4 font-bold text-blue-800 text-lg">Type de Document</th>
                    <th className="text-left py-4 px-4 font-bold text-blue-800 text-lg">Problème de rédaction</th>
                    <th className="text-left py-4 px-4 font-bold text-blue-800 text-lg">Ma solution</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  <tr className="border-b border-slate-200">
                    <td className="py-3 px-4 font-medium">Manuel technique</td>
                    <td className="py-3 px-4 text-slate-600">Jargon incompréhensible pour l'utilisateur</td>
                    <td className="py-3 px-4 text-slate-600">Vulgarisation sans perte de précision technique</td>
                  </tr>
                  <tr className="border-b border-slate-200">
                    <td className="py-3 px-4 font-medium">Fiche produit</td>
                    <td className="py-3 px-4 text-slate-600">Caractéristiques techniques brutes</td>
                    <td className="py-3 px-4 text-slate-600">Mise en valeur des avantages opérationnels</td>
                  </tr>
                  <tr className="border-b border-slate-200">
                    <td className="py-3 px-4 font-medium">Rapport d'expertise</td>
                    <td className="py-3 px-4 text-slate-600">Structure confuse, conclusions noyées</td>
                    <td className="py-3 px-4 text-slate-600">Architecture claire, synthèse percutante</td>
                  </tr>
                  <tr className="border-b border-slate-200">
                    <td className="py-3 px-4 font-medium">Présentation commerciale</td>
                    <td className="py-3 px-4 text-slate-600">Discours technique qui n'accroche pas</td>
                    <td className="py-3 px-4 text-slate-600">Storytelling technique qui convainc</td>
                  </tr>
                  <tr className="border-b border-slate-200">
                    <td className="py-3 px-4 font-medium">Article de blog</td>
                    <td className="py-3 px-4 text-slate-600">Sujet complexe, audience large</td>
                    <td className="py-3 px-4 text-slate-600">Vulgarisation engageante avec exemples concrets</td>
                  </tr>
                  <tr className="border-b border-slate-200">
                    <td className="py-3 px-4 font-medium">Traduction technique</td>
                    <td className="py-3 px-4 text-slate-600">Perte du sens technique en anglais</td>
                    <td className="py-3 px-4 text-slate-600">Adaptation culturelle et technique précise</td>
                  </tr>
                  <tr>
                    <td className="py-3 px-4 font-medium">Formation technique</td>
                    <td className="py-3 px-4 text-slate-600">Contenu aride, participants décrochent</td>
                    <td className="py-3 px-4 text-slate-600">Pédagogie active avec retour d'expérience</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-slate-800 mb-2">Services</h2>
            <h3 className="text-2xl lg:text-3xl font-semibold text-blue-600 mb-8">Ce que je peux faire pour vous</h3>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <ul className="space-y-6 text-lg">
              <li className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Article/fiche technique</h4>
                  <p className="text-slate-600">Documentation technique précise, manuels d'utilisation, spécifications produits</p>
                </div>
              </li>
              
              <li className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Communication grand-public</h4>
                  <p className="text-slate-600">Vulgarisation de sujets techniques complexes pour le grand public</p>
                </div>
              </li>
              
              <li className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">White paper/Rapport</h4>
                  <p className="text-slate-600">Rapports d'expertise, études techniques, analyses stratégiques</p>
                </div>
              </li>
              
              <li className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Newsletter/Articles de blog</h4>
                  <p className="text-slate-600">Contenus réguliers, articles LinkedIn, communications internes</p>
                </div>
              </li>
              
              <li className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Personal branding/Shadow writing</h4>
                  <p className="text-slate-600">Rédaction sous votre signature, développement de votre image d'expert</p>
                </div>
              </li>
              
              <li className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Traduction/Rewriting</h4>
                  <p className="text-slate-600">Traduction FR&gt;EN/DE, amélioration de textes techniques existants</p>
                </div>
              </li>
              
              <li className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Contenus pédagogiques</h4>
                  <p className="text-slate-600">Supports de formation, guides d'apprentissage, contenus éducatifs</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* A propos Section */}
      <section id="apropos" className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-bold text-slate-800 mb-8 text-center">A propos</h2>
            
            <div className="prose prose-lg max-w-none text-slate-600">
              <h3 className="text-2xl font-semibold text-slate-800 mb-6">Expérience professionnelle</h3>
              
              <div className="space-y-6">
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Officier de Marine</h4>
                  <p>Commandant en Second de l'aviso-escorteur Commandant Bourdais.</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Service détaché auprès de la Bundesmarine</h4>
                  <p>Officier de quart sur le croiseur-école Deutschland. Cet embarquement m'a permis de maîtriser le jargon naval technique allemand et d'acquérir une vision opérationnelle internationale.</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Pilote de chasse embarqué</h4>
                  <p>Commandant de la Flottille 17 F. Couvre tous les aspects opérationnels de l'aviation d'assaut embarquée y compris appontage de nuit.</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Officier de programme Super-Étendard</h4>
                  <p>Développement/intégration des missiles AM 39 et ASMP. Développement intégration de contre-mesures électroniques (brouilleurs et lance-leurres).</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Service détaché auprès du Flieger Geschwader II</h4>
                  <p>Service sur F-104.</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Ingénieur export</h4>
                  <p>USA, Israël, Inde. Direction de réponse à une RFP US pour un détecteur MAD. Choix et management du sous-traitant US.</p>
                </div>
                
                <div>
                  <h4 className="font-semibold text-slate-800 mb-2">Analyste Stratégique Sextant Avionique</h4>
                  <p>Analyse des marchés, identification d'opportunités, et définition des orientations technologiques pour les systèmes aéronautiques. Vision globale, combinant technique et stratégie industrielle.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-slate-800 mb-4">
              Portfolio
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Exemples d'articles et projets réalisés - Précision technique et style narratif
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Card className="hover:shadow-lg transition-shadow border-l-4 border-l-blue-600">
              <CardHeader>
                <CardTitle className="text-lg">Le Super-Etendard</CardTitle>
                <CardDescription className="mb-4">
                  "Quand l'innovation naît des contraintes" - Article technique
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-slate-600 italic mb-2">
                  "En 1970 la Marine Nationale entame une réflexion sur le remplacement de l'Etendard... 
                  On opte pour un compromis qui, de prime abord, ne semble pas voué à un grand avenir..."
                </p>
                
                <Dialog>
                  <DialogTrigger asChild>
                    <Button variant="outline" size="sm" className="w-full">
                      Lire l'article complet
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
                    <DialogHeader>
                      <DialogTitle>Le Super-Etendard</DialogTitle>
                      <DialogDescription>Quand l'innovation nait des contraintes</DialogDescription>
                    </DialogHeader>
                    <div className="prose prose-slate max-w-none text-sm">
                      <p>En 1970 la Marine Nationale entame une réflexion sur le remplacement de l'Etendard. La généralisation des défenses anti-aériennes à base de missiles va rendre l'avion obsolète. Budget serré, exigences techniques élevées.</p>
                      
                      <h3>Contexte</h3>
                      <p>Le nouvel avion devra intégrer le missile Air/mer AM 39. Quels sont les choix ?</p>
                      <ul>
                        <li>Navaliser un avion de l'Armée de l'air : L'alourdirait trop.</li>
                        <li>Acheter un avion US : Écarté pour raisons politiques</li>
                        <li>Développer un avion ad-hoc : Trop coûteux.</li>
                      </ul>
                      
                      <h3>Genèse du concept</h3>
                      <p>On opte donc pour un compromis qui, de prime abord, ne semble pas voué à un grand avenir : partir d'une cellule éprouvée, celle de l'Étendard IV M et moderniser le système d'arme, essentiellement pour permettre l'emport de l'Exocet dans sa version aéroportée (AM 39).</p>
                      
                      <p>Les coûts seront réduits puisque les outillages de fabrication de l'Etendard IV M ont été conservés.</p>
                      
                      <p>Deux options sont possibles. La première, a minima, consiste à doter l'avion d'un radar de surface digne de ce nom et d'un point d'emport AM 39. Certaines hautes autorités, dont le major-général de la Marine y sont favorables.</p>
                      
                      <p>D'autres, plus jeunes, gravitant autour de l'équipe chargée du développement avion, militent pour une modernisation beaucoup plus radicale. Doter l'avion d'une centrale inertielle, ce qui entraîne presque obligatoirement de l'équiper d'un viseur tête haute et d'un calculateur numérique embarqué.</p>
                      
                      <p>Faut-il une centrale inertielle pour tirer l'AM 39 ? Stricto sensu : non. D'ailleurs, aux yeux des décideurs de l'époque, une centrale à inertie et ce qui va avec, viseur tête-haute, calculateur numérique, c'est bien cher, bien fragile, et cela semble surtout un luxe inutile.</p>
                      
                      <p>L'équipe de Service Central de l'Aéronautique Navale pense différemment. Elle sait que la fonction essentielle de la centrale inertielle est d'augmenter considérablement la précision du tir de bombe. Cette option est dans la ligne de l'amélioration pas à pas suivie par le constructeur Dassault qui vient de moderniser le F1 pour le tir AM 39.</p>
                      
                      <p>Avec cet équipement on peut s'attendre à un Écart Circulaire Probable (ECP) de l'ordre de 30 mètres (50 % des bombes à moins de 30 mètres du point visé). Jusque-là, tout le monde, US Navy comprise, a tiré mal et beaucoup en comptant sur la chance pour mettre un coup au but. Avec l'inertie, l'ère des armes de précision s'ouvre.</p>
                      
                      <h3>Un astucieux marchandage</h3>
                      <p>On se résout à une formule astucieuse qui ménage les tenants des deux solutions. Une enveloppe budgétaire globale est fixée, elle prévoit la construction de 100 Etendard IV M. Libre à la Marine d'adopter les modifications qui lui paraîtront nécessaires.</p>
                      
                      <p>Le coût de celles-ci se traduira par autant d'avions en moins. Le marché est notifié au constructeur en 1975. Une centaine de modifications font partie de la définition du Super-Etendard initial. Elles coûtent l'équivalent de 29 avions. Dassault en livrera donc 71. Fait symbolique, la modification N° 1 est l'emport d'une centrale inertielle.</p>
                      
                      <h3>La même cellule ? Pas tout à fait.</h3>
                      <p>Aux yeux du profane, à part le gros nez du radar, le nouvel avion est la copie de l'ancien. En réalité il est meilleur.</p>
                      
                      <p>La cellule rallongée de 38 cm permet d'augmenter le pétrole interne de presque 500 kg. 50 à 80 Nautiques de rayon d'action en plus, suivant le profil de mission.</p>
                      
                      <p>Diverses améliorations des dispositifs hyper-sustentateurs et autres ont permis de réduire la vitesse d'appontage de presque 15 nœuds. C'est capital ! L'appontage de nuit, auquel on avait fini par renoncer pour le IV M, devient opérationnellement praticable. La vitesse relative par rapport au PA lors de l'appontage est de l'ordre de 100 nœuds. Voisine de celle que pratiquent les Américains.</p>
                      
                      <h3>Un avion évolutif</h3>
                      <p>Il n'est pas certain que la capacité du système d'arme à évoluer et à permettre l'emport d'armements non prévus ait été envisagée dès le départ comme une retombée de l'architecture « système » de l'avionique.</p>
                      
                      <p>Cette capacité à évoluer s'est révélée essentielle. Elle a permis au Super Etendard d'évoluer et de ne pas devenir obsolète au bout de quelques années comme son prédécesseur l'Etendard IV M.</p>
                      
                      <ul>
                        <li>Intégration de liaisons de données tactiques (Liaison 11/16).</li>
                        <li>Emport d'armements modernes (GBU-12, missile nucléaire ASMP).</li>
                        <li>Intégration d'un pod de désignation laser</li>
                        <li>Améliorations des contre-mesures électroniques pour faire face aux défenses aériennes évoluées.</li>
                      </ul>
                      
                      <h3>Une révolution silencieuse</h3>
                      <p>Il y a cinquante ans, lorsqu'on a pris la décision de lancer la construction en série du Super-Étendard, se doutait-on que, vingt-cinq ans plus tard, on verrait la mise en service de la 5ᵉ version du système d'arme ? Sûrement pas. On venait d'initier, sans le savoir et sans le vouloir, une « révolution silencieuse » qui a permis à l'aviation embarquée de remplir plus qu'honorablement les missions qui lui ont été confiées pendant presque quarante ans au Liban, en ex-Yougoslavie, en Afghanistan et en Irak.</p>
                    </div>
                  </DialogContent>
                </Dialog>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow border-l-4 border-l-yellow-500">
              <CardHeader>
                <CardTitle className="text-lg">Train d'atterrissage embarqué</CardTitle>
                <CardDescription className="mb-4">
                  "Un miracle de résistance" - Article grand-public
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-slate-600 italic mb-2">
                  "Montez sur une table pas très haute (60 centimètres). Sautez par terre. 
                  Vous arriverez au sol à la vitesse verticale d'un avion qui apponte..."
                </p>
                
                <Dialog>
                  <DialogTrigger asChild>
                    <Button variant="outline" size="sm" className="w-full">
                      Lire l'article complet
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
                    <DialogHeader>
                      <DialogTitle>Le train d'atterrissage d'un avion embarqué</DialogTitle>
                      <DialogDescription>Un miracle de résistance dans une jambe de train</DialogDescription>
                    </DialogHeader>
                    <div className="prose prose-slate max-w-none text-sm">
                      <p>Montez sur une table pas très haute (60 centimètres). Sautez par terre. Vous arriverez au sol à la vitesse verticale d'un avion qui apponte.</p>
                      
                      <p>Maintenant, imaginez que vous faites la même chose avec 5 tonnes sur le dos. Vous avez l'image exacte de ce que doit supporter la jambe de train d'un Rafale à chaque appontage.</p>
                      
                      <p>On ne se rend pas bien compte combien ça doit être solide, ni de la quantité énorme d'énergie à absorber.</p>
                      
                      <h3>Pour fixer les idées</h3>
                      <p>L'amortisseur d'un Rafale qui apponte encaisse 25 fois plus d'énergie et subit des efforts 10 fois plus importants que celui d'une voiture lancée à pleine vitesse qui monte sur un trottoir de 10 cm de haut. Cet amortisseur est aussi trois fois plus long que celui de votre SUV. C'est ce qui évite au pilote de perdre son dentier à chaque appontage.</p>
                      
                      <h3>Une expérience révélatrice</h3>
                      <p>L'auteur de ces lignes n'a pris réellement conscience des forces encaissées par une jambe de train que quelque part au milieu de l'océan Atlantique, loin de toute terre habitée. Ce matin-là, après catapultage, pour une raison apparemment mystérieuse, son train n'a pas voulu rentrer.</p>
                      
                      <p>Après une inspection à vue par un petit copain qui s'est mis en patrouille serrée, il a été déclaré « canard boiteux » par le chef avia et prié de rejoindre le circuit d'attente du même nom où il a patiemment brûlé le pétrole de la République en attendant l'appontage.</p>
                      
                      <p>C'est au moment où ses roues ont touché le pont que « la chose » s'est produite. Un bruit qui fait s'arrêter le cœur, profond, de chose qui se rompt, qui se déchire. Un bruit qu'il a ressenti dans tout son corps, annonciateur de catastrophe.</p>
                      
                      <h3>La découverte</h3>
                      <p>Une heure plus tard, le patron de flottille a passé la tête par la porte de la salle d'alerte. Au fond du hangar, le destrier reposait déjà sur des chandelles d'acier, comme une voiture accidentée.</p>
                      
                      <p>C'était la preuve irréfutable de la violence du choc à l'appontage. La jambe du train s'était enfoncée dans le caisson de voilure. Axe arraché, roulement explosé, métal ployé et déchiré comme du papier de soie. On aurait dit un bâtonnet enfoncé dans un Esquimau. Tout ça parce que l'amortisseur, vidé de son huile, n'avait pas rempli son office.</p>
                    </div>
                  </DialogContent>
                </Dialog>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow border-l-4 border-l-green-600">
              <CardHeader>
                <CardTitle className="text-lg">Rewriting Technique Anglais</CardTitle>
                <CardDescription className="mb-4">
                  "RTM Process: From Technical to Marketing" - Transformation
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-slate-600 italic mb-2">
                  "PROPS blades, hubs, and spinners are produced using RTM — the same cutting-edge process 
                  trusted by AIRBUS and BOEING..."
                </p>
                
                <Dialog>
                  <DialogTrigger asChild>
                    <Button variant="outline" size="sm" className="w-full">
                      Voir l'exemple complet
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="max-w-6xl max-h-[80vh] overflow-y-auto">
                    <DialogHeader>
                      <DialogTitle>Rewriting et amélioration de texte technique anglais</DialogTitle>
                      <DialogDescription>Trois versions d'un document technique - Du brut au marketing</DialogDescription>
                    </DialogHeader>
                    <div className="prose prose-slate max-w-none text-sm">
                      <div className="grid md:grid-cols-3 gap-6">
                        <div>
                          <h3 className="text-red-600">Version originale</h3>
                          <p className="text-xs bg-red-50 p-3 rounded">
                            PROPS parts, blades, hubs and spinners, are made with manufacturing process called RTM (Resin Transfer Molding). This process is used by major companies as AIRBUS and BOEING for some critical ultra-light carbon parts on liner aircraft. RTM is one of the best methods for mass production of composite parts.
                          </p>
                          <p className="text-xs bg-red-50 p-3 rounded mt-2">
                            There are several benefits to using the Resin Transfer Molding process over the alternative processes available. Some key benefits include : - Very good surface quality - Very high fibers ratio - Wide range of reinforcements
                          </p>
                        </div>
                        
                        <div>
                          <h3 className="text-blue-600">Version rewritée technique</h3>
                          <p className="text-xs bg-blue-50 p-3 rounded">
                            PROPS parts — blades, hubs, and spinners — are manufactured using RTM (Resin Transfer Molding). This advanced process is also employed by leading aerospace companies such as AIRBUS and BOEING for critical ultra-light carbon components in commercial aircraft.
                          </p>
                          <p className="text-xs bg-blue-50 p-3 rounded mt-2">
                            The Resin Transfer Molding process offers several advantages compared to other methods. Key benefits include: - Excellent surface quality - High fiber-to-resin ratio - Compatibility with a wide range of reinforcements
                          </p>
                        </div>
                        
                        <div>
                          <h3 className="text-green-600">Version marketing</h3>
                          <p className="text-xs bg-green-50 p-3 rounded">
                            PROPS blades, hubs, and spinners are produced using RTM (Resin Transfer Molding) — the same cutting-edge process trusted by AIRBUS and BOEING. This technology allows us to create high-performance composite parts with flawless finishes.
                          </p>
                          <p className="text-xs bg-green-50 p-3 rounded mt-2">
                            Why RTM? Because it delivers unmatched advantages: - Flawless surface finish - Optimal fiber-to-resin balance for maximum strength - Adaptability to a wide variety of reinforcements
                          </p>
                        </div>
                      </div>
                      
                      <div className="mt-6 p-4 bg-slate-100 rounded">
                        <h4 className="font-semibold mb-2">Transformation réalisée :</h4>
                        <ul className="text-sm space-y-1">
                          <li>✓ Correction grammaticale et syntaxique</li>
                          <li>✓ Amélioration du style et de la fluidité</li>
                          <li>✓ Ajout d'une dimension marketing</li>
                          <li>✓ Renforcement de l'impact commercial</li>
                        </ul>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>
              </CardContent>
            </Card>

            <Card className="hover:shadow-lg transition-shadow border-l-4 border-l-red-600">
              <CardHeader>
                <CardTitle className="text-lg">Fiche technique : Système d'arme Super-Etendard/AM 39</CardTitle>
                <CardDescription className="mb-4">
                  "Enseignements de la Guerre des Malouines" - Analyse technique complète
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-slate-600 italic mb-2">
                  "Le système d'arme Super Étendard/AM39 a été conçu dans les années 1970 pour contrer la flotte soviétique... 
                  Malgré un déploiement limité, les résultats sont impressionnants..."
                </p>
                
                <Dialog>
                  <DialogTrigger asChild>
                    <Button variant="outline" size="sm" className="w-full">
                      Lire la fiche complète
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="max-w-6xl max-h-[80vh] overflow-y-auto">
                    <DialogHeader>
                      <DialogTitle>Fiche technique : Le système d'arme Super Étendard/AM39 durant la guerre des Malouines (1982)</DialogTitle>
                      <DialogDescription>Enseignements de la Guerre des Malouines</DialogDescription>
                    </DialogHeader>
                    <div className="prose prose-slate max-w-none text-sm">
                      <h3>Introduction</h3>
                      <p>Le système d'arme Super Étendard/AM39 a été conçu dans les années 1970 pour contrer la flotte soviétique en expansion sous l'impulsion de l'amiral Gorchkov. Entré en service dans la Marine nationale en septembre 1978, il obtient sa qualification opérationnelle en 1981 après des essais réussis au polygone du Levant en Méditerranée.</p>
                      
                      <p>En 1982, à peine un an après sa mise en service, ce système est employé par l'Argentine contre la Royal Navy, l'une des marines les plus modernes et entraînées au monde. Malgré le courage et les sacrifices des deux camps, l'efficacité du système Super Étendard/AM39 a failli modifier l'issue du conflit.</p>
                      
                      <p>Cette fiche technique présente un rappel des faits, une description synthétique des composants du système d'arme, et une analyse des retours d'expérience issus de ce conflit, notamment :</p>
                      
                      <p>Le système d'arme Super Étendard/AM39.</p>
                      
                      <p>La vulnérabilité des bâtiments de surface aux missiles antinavires.</p>
                      
                      <p>Les mesures de sécurité et de lutte anti-incendie.</p>
                      
                      <h3>Rappel des faits</h3>
                      <p>La guerre des Malouines (2 avril – 14 juin 1982) oppose le Royaume-Uni à l'Argentine. L'opération argentine, lancée par la junte militaire de Galtieri, est improvisée : sur une commande de 14 Super Étendard et 30 missiles AM39, seuls 5 avions et 5 missiles sont disponibles au début du conflit. La France retarde la livraison des missiles restants.</p>
                      
                      <p>Malgré ces contraintes, la force aérienne de l'Armada argentine fait preuve d'un grand professionnalisme.</p>
                      
                      <p>Les 5 missiles disponibles sont tirés lors de 3 raids :</p>
                      
                      <div className="overflow-x-auto my-4">
                        <table className="w-full border border-slate-300">
                          <thead>
                            <tr className="bg-slate-100">
                              <th className="border border-slate-300 p-2 text-left">Date</th>
                              <th className="border border-slate-300 p-2 text-left">Équipage</th>
                              <th className="border border-slate-300 p-2 text-left">Profil/Rayon d'action</th>
                              <th className="border border-slate-300 p-2 text-left">Détection</th>
                              <th className="border border-slate-300 p-2 text-left">Résultat</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="border border-slate-300 p-2">4 mai</td>
                              <td className="border border-slate-300 p-2">Bedacarratz<br />Mayora</td>
                              <td className="border border-slate-300 p-2">Entièrement Basse altitude<br />1 Ravitaillement en vol<br />390 Nautiques</td>
                              <td className="border border-slate-300 p-2">Préalable par "shadower" Neptune<br />Position rafraîchie quand SUE à 100 Nautiques<br />Pop-up et Radar SUE On à 30 Nautiques<br />Tir à 15 Nautiques</td>
                              <td className="border border-slate-300 p-2">1 missile but<br />1 missile splash<br />Sheffield en feu<br />Coulé</td>
                            </tr>
                            <tr>
                              <td className="border border-slate-300 p-2">25 mai</td>
                              <td className="border border-slate-300 p-2">Curilovic<br />Barazza</td>
                              <td className="border border-slate-300 p-2">Profil Haute altitude/Basse Altitude/Haute altitude<br />2 Ravitaillement en vol<br />750 Nautiques</td>
                              <td className="border border-slate-300 p-2">Par radar à terre sur les Malouines<br />Position rafraîchie avant l'attaque<br />Pop-up et Radar SUE On à 35 Nautiques<br />Tir à 15 Nautiques</td>
                              <td className="border border-slate-300 p-2">2 missiles but<br />Atlantic Conveyor en feu<br />Coulé</td>
                            </tr>
                            <tr>
                              <td className="border border-slate-300 p-2">30 mai</td>
                              <td className="border border-slate-300 p-2">Francisco<br />Collavino</td>
                              <td className="border border-slate-300 p-2">Profil Haute altitude/Basse Altitude<br />1 Ravitaillement en vol<br />550 Nautiques</td>
                              <td className="border border-slate-300 p-2">Après le débarquement à Port-Stanley<br />Fix radar à 100 Nautiques S/E de Port Stanley<br />3 Pop-up successifs à 55 40 et 25 Nautiques<br />Tir à 20 Nautiques</td>
                              <td className="border border-slate-300 p-2">5ème missile tiré<br />probablement sur Invincible<br />Intercepté par Sea Dart ou leurré</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      
                      <p><strong>Légende :</strong></p>
                      <p>NM = Nautiques. "Shadower" = avion de guet Neptune. "Splash" = missile non impactant</p>
                      
                      <p>Malgré un déploiement limité, les résultats sont impressionnants. À deux reprises, l'Invincible a été dans la ligne de mire des Super Étendard. L'amiral Woodward a déclaré qu'un impact aurait pu contraindre la Royal Navy à annuler l'opération.</p>
                      
                      <h3>Le système d'arme</h3>
                      <p>Maîtres d'ouvrage : Marine nationale et Service Technique des Constructions Aéronautiques. Maître d'œuvre : Dassault/Breguet Aviation, avec le concours de Thales (Thomson-CSF à l'époque) pour le radar Agave, et MBDA (Aérospatiale) pour le missile Exocet.</p>
                      
                      <h4>1. Super Étendard : Plateforme d'attaque</h4>
                      <p>Configuration argentine : 1 AM39, 1 bidon sous voilure, 1 bidon ventral.</p>
                      
                      <p><strong>Caractéristiques :</strong></p>
                      <ul>
                        <li>Masse au décollage : 11 500 kg.</li>
                        <li>Propulsion : Turboréacteur SNECMA Atar 8K-50 (50 kN de poussée).</li>
                        <li>Vitesse maximale : 480 nœuds à basse altitude.</li>
                        <li>Carburant : 3 200 kg (interne) + 500 kg (réservoir sous aile) + 300 kg (réservoir ventral).</li>
                        <li>Armement : 1 missile AM39 sous voilure.</li>
                        <li>Autoprotection : Système d'alerte radar (RWR) et leurres basiques.</li>
                      </ul>
                      
                      <p><strong>Points clés :</strong></p>
                      <ul>
                        <li>Conçu pour des missions d'attaque antinavire en environnement hostile.</li>
                        <li>Stabilité en vol rasant (20-50 m) grâce à une aile en flèche modérée (45°).</li>
                        <li>Limites : Autonomie insuffisante pour le théâtre d'opérations, ergonomie perfectible.</li>
                      </ul>
                      
                      <h4>2. Radar Agave : Détection et acquisition de cible</h4>
                      <p>Développé par : Thomson-CSF (Thales).</p>
                      <ul>
                        <li>Bande de fréquence : I/J (8-20 GHz).</li>
                        <li>Portée de détection : ~70 NM pour un destroyer (conditions idéales).</li>
                      </ul>
                      
                      <p><strong>Points clés :</strong></p>
                      <ul>
                        <li>Mode air-mer optimisé pour la détection de cibles navales.</li>
                        <li>Guidage du missile AM39 : Acquisition en mode balayage, puis verrouillage sur la cible.</li>
                        <li>Vulnérabilités : Sensible aux brouilleurs (Type 670 britannique), portée réduite à très basse altitude.</li>
                      </ul>
                      
                      <h4>3. Missile AM39 Exocet : Arme antinavire</h4>
                      <p>Développé par : Aérospatiale (MBDA).</p>
                      <p>Qualification opérationnelle : 1981.</p>
                      <ul>
                        <li>Portée : 40-70 km (selon altitude de largage).</li>
                        <li>Guidage :</li>
                        <li>Phase initiale : Centrale inertielle.</li>
                        <li>Phase terminale : Autodirecteur radar actif.</li>
                        <li>Vitesse : Mach 0,9 en croisière, Mach 0,95 en phase terminale.</li>
                        <li>Charge militaire : 165 kg (effet de souffle et incendies).</li>
                      </ul>
                      
                      <p><strong>Points clés :</strong></p>
                      <ul>
                        <li>Profil de vol : Très basse altitude (3-5 m) pour éviter la détection radar.</li>
                        <li>Efficacité : Capable de neutraliser des navires par explosion ou incendie.</li>
                        <li>Vulnérabilités : Sensible aux leurres (Sea Gnat), autodirecteur perturbable par des brouilleurs.</li>
                      </ul>
                      
                      <h4>4. Synthèse du système d'arme</h4>
                      <p><strong>Intégration et efficacité :</strong></p>
                      <ul>
                        <li>Conçu pour neutraliser des cibles navales à distance.</li>
                        <li>Furtivité relative : Approche à très basse altitude pour retarder la détection, mais nécessité de monter à ~30 NM pour acquérir et verrouiller la cible, suivi d'une descente en TBA</li>
                        <li>Tir à 15-20 NM, pour réduire le temps de vol du missile.</li>
                      </ul>
                      
                      <h3>Retours d'expérience sur le système d'arme Super Étendard/AM39</h3>
                      
                      <h4>1. Efficacité opérationnelle prouvée</h4>
                      <p><strong>Points forts identifiés :</strong></p>
                      <ul>
                        <li>Le profil de vol à 100 pieds (TBA) retarde la détection par les radars britanniques (Type 1022, 965).</li>
                        <li>Le radar Agave a démontré sa capacité à acquérir des cibles malgré sa sensibilité aux contre-mesures.</li>
                        <li>Le missile AM39 a confirmé sa capacité à neutraliser des navires modernes (Sheffield, Atlantic Conveyor) avec une charge de 165 kg, provoquant des incendies incontrôlables.</li>
                      </ul>
                      
                      <p>Nota : La commission d'enquête britannique a confirmé que le missile ayant touché le Sheffield a bien explosé.</p>
                      
                      <p><strong>Flexibilité tactique :</strong></p>
                      <p>Les pilotes argentins ont su adapter leurs profils de mission (pop-up à 30-35 NM, tir à 15-20 NM) pour maximiser les chances de succès, malgré un entraînement limité.</p>
                      
                      <h4>2. Vulnérabilités et limites du système</h4>
                      <p><strong>Faiblesses critiques :</strong></p>
                      <ul>
                        <li>Détection et contre-mesures : Le radar Agave est vulnérable aux brouilleurs (Type 670) et aux leurres (Sea Gnat).</li>
                        <li>Autonomie et logistique : Le rayon d'action limité du Super Étendard a contraint les Argentins à des ravitaillements en vol risqués.</li>
                        <li>Vulnérabilité post-tir : Après le pop-up et le tir, le Super Étendard reste exposé pendant 20-30 secondes, vulnérable aux missiles sol-air (Sea Dart).</li>
                        <li>Ergonomie et charge de travail : La gestion manuelle du radar (affichage analogique) et l'absence d'automatisation ont imposé une charge cognitive élevée aux pilotes.</li>
                      </ul>
                      
                      <h4>3. Améliorations suggérées pour les systèmes futurs</h4>
                      <p><strong>Pour la plateforme :</strong></p>
                      <ul>
                        <li>Radar et guerre électronique : Intégrer des contre-mesures électroniques actives.</li>
                        <li>Autonomie : Augmenter la capacité en carburant pour réduire la dépendance aux ravitaillements en vol.</li>
                        <li>Profil de mission et survie : Intégrer des leurres automatiques pour saturer les défenses ennemies.</li>
                        <li>Ergonomie et automatisation : Moderniser les visualisations en recourant aux écrans multifonctions et automatiser les séquences de tir.</li>
                      </ul>
                      
                      <p><strong>Pour les missiles :</strong></p>
                      <p>L'AM39 Block 2 (années 1990) a intégré un guidage GPS/INS, réduisant la dépendance au radar et améliorant la résistance aux contre-mesures.</p>
                      
                      <h3>Retours d'expérience pour les bâtiments de surface</h3>
                      
                      <p><strong>Réévaluation des défenses antinavires :</strong></p>
                      <p>Développement de systèmes de défense rapprochée (Sea Wolf, Phalanx) pour engager les missiles en phase terminale.</p>
                      
                      <p><strong>Lutte anti-incendie :</strong></p>
                      <p>Réforme majeure des systèmes de lutte anti-incendie : suppression des revêtements en polyuréthane, port de tenues anti-flash, interdiction des sous-vêtements synthétiques.</p>
                      
                      <p><strong>Nécessité d'augmenter la furtivité :</strong></p>
                      <p>Déploiement progressif de navires furtifs (coque en V, superstructures inclinées).</p>
                      
                      <p>La guerre des Malouines a révélé la vulnérabilité des bâtiments de surface aux missiles anti-navires. Des conflits récents (neutralisation de la flotte russe en mer Noire par l'Ukraine, perturbations du trafic en mer Rouge par les Houthis) montrent que cette menace reste critique pour les marines.</p>
                      
                      <h3>Conclusion</h3>
                      <p>Le système Super Étendard/AM39 a démontré une efficacité opérationnelle remarquable malgré ses limites. Les leçons tirées de son emploi ont influencé la conception des systèmes d'armes modernes et les doctrines de défense navale. Cette analyse souligne l'importance de l'intégration avion-missile, de la résistance aux contre-mesures, et de l'adaptation tactique pour répondre aux menaces évolutives.</p>
                    </div>
                  </DialogContent>
                </Dialog>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Discutons de votre projet
              </h2>
              <p className="text-xl text-slate-300 mb-8">Vous avez un projet de communication technique dans l'aéronautique ou la défense ? Contactons-moi pour en discuter.</p>
              
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                    <Mail className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold">Email</h3>
                    <p className="text-slate-300">b.krebs@aero-copywriter.fr</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                    <Phone className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold">Téléphone</h3>
                    <p className="text-slate-300">06 59 99 89 62</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                    <Linkedin className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-semibold">LinkedIn</h3>
                    <p className="text-slate-300">linkedin.com/in/copywriter-aeronautique</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-slate-800 rounded-lg p-8">
              <h3 className="text-2xl font-bold mb-6">Demande de devis</h3>
              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-medium mb-2">Nom complet</label>
                  <input type="text" className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white" placeholder="Votre nom" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Email</label>
                  <input type="email" className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white" placeholder="votre@email.com" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Type de projet</label>
                  <select className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white">
                    <option>Documentation technique</option>
                    <option>Communication marketing</option>
                    <option>Formation & conseil</option>
                    <option>Autre</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Description du projet</label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white" placeholder="Décrivez votre projet..."></textarea>
                </div>
                <Button className="w-full bg-yellow-500 hover:bg-yellow-600 text-slate-900 font-semibold">
                  Envoyer la demande
                </Button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-400 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-2 mb-4 md:mb-0">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">AC</span>
              </div>
              <div className="flex flex-col">
                <span className="font-semibold">aéro-copywriter</span>
                <span className="text-xs text-slate-500">www.aéro-copywriter.fr</span>
              </div>
            </div>
            <div className="text-center md:text-right">
              <p>© 2024 aéro-copywriter.fr - Tous droits réservés.</p>
              <p className="text-sm mt-1">Spécialiste en communication technique pour l'industrie aéronautique et défense</p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Index;